import { render, staticRenderFns } from "./LinkOrUpload.vue?vue&type=template&id=567335fc&scoped=true&"
import script from "./LinkOrUpload.vue?vue&type=script&lang=js&"
export * from "./LinkOrUpload.vue?vue&type=script&lang=js&"
import style0 from "./LinkOrUpload.vue?vue&type=style&index=0&id=567335fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567335fc",
  null
  
)

/* custom blocks */
import block0 from "./LinkOrUpload.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

component.options.__file = "LinkOrUpload.vue"
export default component.exports